module.exports = __webpack_public_path__ + "static/media/edit.b03d9e6f.svg";